import { FormControlLabel, Radio } from '@mui/material';
import { StyledRadioRow, StyledRadioText } from '../PdfExportConfigDialog.styles';
import { RadioOptionProps } from './SubOptions.types';

export const RadioOption = ({ value, label }: RadioOptionProps) => (
  <StyledRadioRow>
    <FormControlLabel value={value} control={<Radio />} label={<StyledRadioText>{label}</StyledRadioText>} />
  </StyledRadioRow>
);
